import { TaskViewModel } from "../taskPane/TaskPaneContent.types";
import { useParams } from "react-router";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export default function useTaskPdfHooks() {
    const { taskId } = useParams<{ taskId: string }>();
    const url = `/task/${taskId}`;

    const { data } = useDotLegalQuery<TaskViewModel>(url);

    return { task: data };
}
